import { GET_FAVORIT_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

async function updateFavoriteList({ userToken, id }) {
  const res = await fetch(GET_FAVORIT_ENDPOINT, {
    method: 'POST',
    body: JSON.stringify({
      product_id: id,
    }),
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  });
  return await res.json();
}
async function removeFromUserFavorties({ userToken, id }) {
  const res = await fetch(`${GET_FAVORIT_ENDPOINT}?product_id=${id}`, {
    method: 'delete',
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      Accept: 'application/json',
    }),
  });
  return await res.json();
}
async function getUserFavorites(token) {
  const res = await fetch(`${GET_FAVORIT_ENDPOINT}`, {
    method: 'get',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    }),
  });
  return await res.json();
}

const useUserFavorties = (token, initiaData) => {
  const fallback = [];
  const { data: userFavorites = fallback } = useQuery({
    queryKey: ['favoritList', token],
    queryFn: () => getUserFavorites(token),
    initialData: initiaData,
  });
  return { userFavorites };
};
const useUpdateFavorite = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, id }) => updateFavoriteList({ userToken, id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['favoritList', token]);
    },
  });
};
const useRemoveFromFavorite = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, id }) =>
      removeFromUserFavorties({ userToken, id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['favoritList', token]);
    },
  });
};
export { useUpdateFavorite, useUserFavorties, useRemoveFromFavorite };
